import { render, staticRenderFns } from "./IndicaIcon.vue?vue&type=template&id=a43ddff4&"
import script from "./IndicaIcon.vue?vue&type=script&lang=ts&"
export * from "./IndicaIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports